<script setup lang="ts">
import type { SliderRootEmits, SliderRootProps } from "radix-vue"
import { SliderRange, SliderRoot, SliderThumb, SliderTrack, useForwardPropsEmits } from "radix-vue"
import { computed, type HTMLAttributes } from "vue"

const props = defineProps<SliderRootProps & { class?: HTMLAttributes["class"] }>()
const emits = defineEmits<SliderRootEmits>()

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props

	return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
	<SliderRoot
		class="relative w-full flex touch-none select-none items-center"
		v-bind="forwarded">
		<SliderTrack class="relative h-2 w-full grow overflow-hidden rounded-full bg-foreground/20">
			<SliderRange class="absolute h-full bg-website-primary" />
		</SliderTrack>

		<SliderThumb
			v-for="(_, key) in modelValue"
			:key="key"
			class="block size-5 border border-foreground/20 rounded-full border-solid bg-background shadow-xl ring-offset-background transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring" />
	</SliderRoot>
</template>
